module.exports = __webpack_public_path__ + "static/img/writingjapaneseanimal_25_optimized.78ab792.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wja/thumbnail/writingjapaneseanimal_25_optimized.jpg
// module id = FnwX
// module chunks = 0